export default {
  items: [
    {
      _name: 'CSidebarNav',
      _children: [
        {
          _name: 'CSidebarNavDropdown',
          name: 'Quản lý slide',
          icon: 'cil-speedometer',
          items: [
            {
              name: 'Danh sách slide',
              to: '/slider-management/managed-sliders',
            }
          ]
        },
        {
          _name: 'CSidebarNavDropdown',
          name: 'Quản lý chính sách',
          icon: 'cil-speedometer',
          items: [
            {
              name: 'Danh sách chính sách',
              to: '/policy-management/managed-policies',
            }
          ]
        },
        {
          _name: 'CSidebarNavDropdown',
          name: 'Quản lý danh mục',
          icon: 'cil-speedometer',
          items: [
            {
              name: 'Danh sách danh mục',
              to: '/category-management/managed-categories',
            }
          ]
        },
        {
          _name: 'CSidebarNavDropdown',
          name: 'Quản lý sản phẩm',
          icon: 'cil-speedometer',
          items: [
            {
              name: 'D/s sản phẩm',
              to: '/products-management/managed-product',
            },
            {
              name: 'D/s sản phẩm khuyến mại',
              to: '/products-management/managed-product-sale',
            }
            // {
            //   name: 'D/s thông số',
            //   to: '/products-management/managed-specification',
            // }
          ]
        },
        {
          _name: 'CSidebarNavDropdown',
          name: 'Quản lý CT khuyến mại',
          icon: 'cil-speedometer',
          items: [
            {
              name: 'Danh sách CT khuyến mại',
              to: '/sale-program-management/managed-sale-program',
            }           
          ]
        },
        
        // {
        //   _name: 'CSidebarNavDropdown',
        //   name: 'Hệ thống',
        //   icon: 'cil-screen-desktop',
        //   items: [{
        //     name: 'D/s tiến trình',
        //     to: '/system-management/managed-threads',
        //   }]
        // },
        // {
        //   _name: 'CSidebarNavDropdown',
        //   name: 'Thống kê',
        //   icon: 'cil-bar-chart',
        //   items: [{
        //     name: 'Lịch sử truy cập',
        //     to: '/statistics-management/managed-access-logs',
        //   }]
        // },
        // {
        //   _name: 'CSidebarNavDropdown',
        //   name: 'Quản lý tài khoản',
        //   icon: 'cil-people',
        //   items: [{
        //     name: 'Hồ sơ cá nhân',
        //     to: '/user-management/my-profile',
        //   },
        //     {
        //       name: 'Danh sách tài khoản',
        //       to: '/user-management/managed-users',
        //     }]
        // }
      ]
    },
  ]
}
